import script from "./UserComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./UserComponents.vue?vue&type=script&setup=true&lang=js"

import "./UserComponents.vue?vue&type=style&index=0&id=503d0ca4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-503d0ca4"]])

export default __exports__